module.exports = __webpack_public_path__ + "static/MantisHub-23d04bf3e64dee0096526a8cc809c618.svg";